/** Cached from GET /governance/dispute-payout-config when available. */
let serverEnabledCache = null;

/** On-chain resolveDispute is opt-in; default off so DAO pool USDC is not drained. */
export const isDaoDisputeOnChainEnabled = () => {
  if (process.env.REACT_APP_BLOCK_DAO_DISPUTE_PAYOUTS === 'true') return false;
  if (process.env.REACT_APP_ALLOW_DAO_DISPUTE_PAYOUTS === 'true') return true;
  if (serverEnabledCache === true) return true;
  return false;
};

export const setDaoDisputeOnChainFromServer = (enabled) => {
  serverEnabledCache = Boolean(enabled);
};

export const DAO_DISPUTE_PAYOUT_DISABLED_MSG =
  'On-chain dispute payouts are disabled. Your DAO pool deposit will not be paid out via resolveDispute from this app.';
